<template>
  <section>
    <share-video-list :query="query" />
  </section>
</template>

<script>
import ShareVideoList from '@/components/home/ShareVideoList'

export default {
  name: 'ShareVideos',
  components: {
    ShareVideoList
  },

  data() {
    const { query } = this.$route

    return {
      query: query
    }
  },
  beforeRouteUpdate(to, from, next) {
    if (to.name === from.name) {
      this.query = to.query
    }

    next()
  }
}
</script>
